<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'故障案例'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">名称</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$validateAuthority(2500000,2509000,2509001)" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onShowAdd">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">添加</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span class="cursor-el" v-if="$validateAuthority(2500000,2509000,2509003)" @click="onShowEdit(props.item)">编辑</span>
                <span class="cursor-el" v-if="$validateAuthority(2500000,2509000,2509002)" @click="onDel(props.item)">删除</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import FailureCaseAddLayer from "../layer/FailureCaseAddLayer";
import InputLayer from "@/pages/layer/InputLayer";
import {getFailureCaseItems, postFailureCaseDel, postFailureCaseEdit} from "@/common/api";

export default {
  name: "FailureCases",
  components: { TableBox },
  data() {
    return {
      action: getFailureCaseItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "标题", name: "title", title: "title", isHtml: false, value: this.getObjValue },
        { state: true, alias: "所属品牌", name: "brandName", title: "brandName", isHtml: false, value: this.getObjValue },
        { state: true, alias: "上传时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue },
        { state: true, alias: "上传人", name: "creator", title: "creator", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(2500000,2509000,[2509002, 2509003]);
    },
    tableFieldNum() {
      let num = this.isOperation ? 1 : 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      return item[field];
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowAdd() {
      this.$layer.iframe({
        content: {
          content: FailureCaseAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["400px", "450px"],
        shadeClose: false,
        title: "添加故障案例"
      });
    },
    onShowEdit(item) {
      this.$layer.iframe({
        content: {
          content: InputLayer,
          parent: this,
          data: {
            inputTitle: "标题",
            placeholder: "请输入标题",
            emptyTips: "请输入标题",
            valueMaxLength: 60,
            defaultValue: item.title,
            confirm: (layerId, value) => {
              postFailureCaseEdit({ id: item.id, title: value })
                  .then(() => {
                    this.$layer.msg("操作成功");
                    this.onReloadData();
                    this.$layer.close(layerId);
                  })
                  .catch(error => {
                    this.$layer.close(layerId);
                    if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
                      this.$layer.msg(error.data.msg);
                    } else {
                      this.$layer.msg("操作失败");
                    }
                  });
            }
          }
        },
        area: ["400px", "200px"],
        shadeClose: false,
        title: "编辑故障案例"
      });
    },
    onDel(item) {
      this.$layer.confirm(`是否删除【${item.title}】？`, layerid => {
        postFailureCaseDel({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 80px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>